
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class UploaderPDFPreview extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly preview?;

  params: any = {};

  @Watch("preview", { immediate: true })
  previewChanged(payload) {
    this.params = payload;
  }

  updateParams() {
    this.$emit("update-preview", this.params);
  }

  get zoomLevel() {
    return `${this.params.zoom}%`;
  }

  updateZoomLevel(val) {
    const { zoom, minZoom, maxZoom } = this.params;

    const newZoomLevel = zoom + val;

    if (newZoomLevel > maxZoom) {
      this.params.zoom = maxZoom;

      return;
    }

    if (newZoomLevel < minZoom) {
      this.params.zoom = minZoom;

      return;
    }

    this.params.zoom = newZoomLevel;

    this.updateParams();
  }
}
